import React, { useEffect } from 'react';
import { withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';

import { sGetIsAuthenticated } from '../../store/reducers/auth';
import styles from './styles';
import Image from '../../components/Image';
import BoligmappaLogoWithName from '../../assets/images/BoligmappaLogoWithName.svg';
import StatusMaintenance from '../../assets/images/status_maintenance.png';
import Link from '../../components/atomic/Link';

const RETRY_INTERVAL = 300000;

const HealthCheck = ({ isAuthenticated, classes }) => {
  const history = useHistory();

  const onRetry = () => {
    if (isAuthenticated) {
      history.push('properties');
    } else {
      history.push('login');
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      onRetry();
    }, RETRY_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={classes.statusPage}>
      <div>
        <Image
          className={classes.logoImage}
          alt="Boligmappa"
          fallbackSrc={BoligmappaLogoWithName}
        />
      </div>
      <div className={classes.statusContent}>
        <Image
          className={classes.maintenanceImage}
          fallbackSrc={StatusMaintenance}
          alt="Vi pusser opp"
        />
        <h2>Vi pusser opp</h2>
        <p>
          <b>Vi er straks tilbake etter litt oppussing og vedlikehold.</b> Prøv
          igjen om en liten stund eller ta kontakt med vår{' '}
          <Link
            to="https://support.boligmappa.no/hc/no"
            isExternal
            openInNewTab
            isNoPadding
          >
            kundesupport
          </Link>
          .
        </p>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  isAuthenticated: sGetIsAuthenticated(state),
});

export default connect(mapStateToProps)(withStyles(styles)(HealthCheck));
